module.exports = __webpack_public_path__ + "static/media/FCP01@l.b83d6196.jpg";